<template>
  <q-dialog v-model="tagOperation">
    <q-card style="width: 320px">
      <div class="q-pa-md">
        <div class="row q-col-gutter-md">
          <div class="col-12">
            <div class="tag-wrapper">
              <div
                class="tag-container"
                v-for="(tag, index) in tags"
                :key="tag.id"
                @click="tagHandler(tag, index)"
              >
                <div
                  class="box"
                  :style="
                    allHandler(tag.id) == 'all' ? `background:${tag.color}` : ''
                  "
                  :class="{
                    'active-tag': allHandler(tag.id) == 'all',
                    'maybe-tag': allHandler(tag.id) == 'some',
                  }"
                >
                  <transition name="component-slide">
                    <i
                      class="fas fa-check"
                      v-if="allHandler(tag.id) == 'all'"
                    ></i>
                    <i
                      class="fas fa-minus"
                      v-else-if="allHandler(tag.id) == 'some'"
                    ></i>
                  </transition>
                </div>
                <div class="tag-name selection-disable" v-text="tag.name"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" style="margin-top: 10px">
          <div class="mt-5 flex-end q-gutter-xs">
            <q-btn color="grey-7" @click="abort">CANCEL</q-btn>
            <q-btn
              :loading="loading"
              :disable="loading"
              @click="save"
              label="Save"
              type="button"
              color="positive"
            >
              <template v-slot:loading>
                <q-spinner-facebook />
              </template>
            </q-btn>
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>
<script>
import axios from "../axios";
export default {
  data() {
    return {
      isMaybe: false,
      loading: false,
      localSelectedVehicles: [],
      tagCache: [],
      clickedIndex: 0,
      maybeValues: [],
      lastClickedTagId: "",
    };
  },
  methods: {
    tagHandler(tag, index) {
      const lastStatus = this.allHandler(tag.id);

      switch (lastStatus) {
        case "all":
          // set none
          this.localSelectedVehicles = this.localSelectedVehicles.map(
            (vehicle) => {
              vehicle.tags = vehicle.tags.filter((t) => t.id !== tag.id);
              return vehicle;
            }
          );
          break;
        case "some":
          // set all
          this.localSelectedVehicles = this.localSelectedVehicles.map(
            (vehicle) => {
              if (!vehicle.tags.find((t) => t.id == tag.id)) {
                vehicle.tags.push(tag);
              }
              return vehicle;
            }
          );
          break;
        case "none":
          // set some
          const oldVehicles = this.tagCache.filter((vehicle) => {
            return vehicle.tags.some((t) => t.id === tag.id);
          });

          if (oldVehicles.length === 0) {
            // todo: rewrite
            this.localSelectedVehicles = this.localSelectedVehicles.map(
              (vehicle) => {
                if (!vehicle.tags.includes(tag)) {
                  vehicle.tags.push(tag);
                }
                return vehicle;
              }
            );
            break;
          }

          this.localSelectedVehicles = this.localSelectedVehicles.map(
            (vehicle) => {
              const prevVehicle = this.tagCache.find(
                (v) => v.id === vehicle.id
              );
              if (prevVehicle.tags.some((t) => t.id === tag.id)) {
                // eskiden vardı
                if (!vehicle.tags.some((t) => t.id === tag.id)) {
                  vehicle.tags.push(tag);
                }
              } else {
                // eskiden yoktu
                vehicle.tags = vehicle.tags.filter((t) => t.id !== tag.id);
              }

              return vehicle;
            }
          );
          break;
      }
    },
    typeHandler(tag_id) {
      const every = this.tagCache.every((veh) => {
        let { tags } = veh;
        return tags.some((t) => t.id === tag_id);
      });
      const some = this.tagCache.some((veh) => {
        let { tags } = veh;
        return tags.some((t) => t.id === tag_id);
      });
      if (some && !every) return true;
    },
    tagResetter(tag_id) {
      const oldVehicles = this.tagCache.filter((vehicle) => {
        return vehicle.tags.some((tag) => tag.id === tag_id);
      });

      this.localSelectedVehicles = this.localSelectedVehicles.map((vehicle) => {
        if (oldVehicles.includes(vehicle)) {
          if (!vehicle.tags.some((tag) => tag.id === tag_id)) {
            const _tag = this.tags.find((t) => t.id === tag_id);
            vehicle.tags.push(_tag);
          }
        } else {
          vehicle.tags = vehicle.tags.filter((tag) => tag.id !== tag_id);
        }

        return vehicle;
      });
    },
    tagPusher(tag) {
      for (let [index, vehicle] of this.localSelectedVehicles.entries()) {
        vehicle.tags = [...vehicle.tags, tag];
      }
    },
    tagSplicer(tag) {
      for (let [index, vehicle] of this.localSelectedVehicles.entries()) {
        let { tags } = vehicle;
        const _tags = tags.filter((t) => t.id !== tag.id);
        vehicle.tags = _tags;
      }
    },
    bodyHandler() {
      let body = [];
      this.localSelectedVehicles.map((item) =>
        body.push({ vehicle: item.id, tags: item.tags.map((item) => item.id) })
      );
      return body;
    },
    dataHandler() {
      let body = [];
      this.localSelectedVehicles.map((item) =>
        body.push({ vehicle: item.id, tags: item.tags })
      );
      return body;
    },
    async save() {
      try {
        this.loading = true;
        const body = await this.bodyHandler();
        const { data } = await axios.post("vehicle-tagging", body);
        const dataHandler = await this.dataHandler();
        this.$store.commit("vehicle/SET_VEHICLES_TAGS_CHANGED", dataHandler);
        this.$emit("resetSelections", true);
      } finally {
        this.loading = false;
        this.tagOperation = false;
      }
    },
    abort() {
      this.tagOperation = false;
    },
    allHandler(tag_id) {
      const every = this.localSelectedVehicles.every((veh) => {
        let { tags } = veh;
        return tags.some((t) => t.id === tag_id);
      });
      const some = this.localSelectedVehicles.some((veh) => {
        let { tags } = veh;
        return tags.some((t) => t.id === tag_id);
      });
      if (every) return "all";
      else if (some) return "some";
      else return "none";
    },
  },
  computed: {
    selectedVehicles: {
      get() {
        return this.$store.state.vehicle.selectedVehicles;
      },
      set(val) {
        this.$store.commit("vehicle/SET_SELECTED_VEHICLES", val);
      },
    },
    tags: {
      get() {
        return this.$store.state.tag.tags;
      },
      set(val) {
        this.$store.commit("tag/SET_TAGS", val);
      },
    },
    tagOperation: {
      get() {
        return this.$store.state.vehicle.tagOperation;
      },
      set(val) {
        this.$store.commit("vehicle/SET_TAG_OPERATION", val);
      },
    },
  },
  watch: {
    lastClickedTagId(n, o) {
      if (n && o) {
        this.clickedIndex = 1;
      }
    },
    tagOperation(n, o) {
      if (n) {
        this.localSelectedVehicles = JSON.parse(
          JSON.stringify(this.selectedVehicles)
        );
        this.tagCache = JSON.parse(JSON.stringify(this.selectedVehicles));
      } else this.tagCache = null;
    },
  },
};
</script>

<style lang="scss">
.active-tag {
  border: none !important;
  i {
    color: #fff;
  }
}
.maybe-tag {
  border: none !important;
  background: rgba(0, 0, 0, 0.54) !important;
  i {
    color: #fff;
  }
}
.tag-wrapper {
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  .tag-container {
    display: flex;
    flex-flow: row nowrap;
    flex: 1;
    cursor: pointer;
    .box {
      position: relative;
      height: 0.5em;
      width: 0.5em;
      min-width: 0.5em;
      font-size: 40px;
      margin-right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 3px;
      border: 2px solid rgba(0, 0, 0, 0.54);
      border-radius: 3px;
      i {
        position: absolute;
        font-size: 14px;
      }
    }
  }
}
</style>
